import {
  FETCH_ALL_RATES_REQUEST,
  FETCH_ALL_RATES_SUCCESS,
  FETCH_ALL_RATES_FAILURE,
} from 'actionTypes';

import createReducer from './createReducer';

export const initialState = {};

const currenciesAllTypesRates = createReducer(initialState, {
  [FETCH_ALL_RATES_REQUEST]: (state, { payload: { cityKey, dateKey } }) => ({
    ...state,
    [cityKey]: {
      ...(state[cityKey] || {}),
      [dateKey]: {
        ...(state[cityKey]?.[dateKey] || {}),
        isFetching: true,
        isInitialized: false,
      },
    },
  }),
  [FETCH_ALL_RATES_SUCCESS]: (
    state,
    { payload: { cityKey, dateKey, entities } }
  ) => ({
    ...state,
    [cityKey]: {
      ...(state[cityKey] || {}),
      [dateKey]: {
        ...(state[cityKey]?.[dateKey] || {}),
        entities,
        isFetching: false,
        isInitialized: true,
      },
    },
  }),
  [FETCH_ALL_RATES_FAILURE]: (state, { payload: { cityKey, dateKey } }) => ({
    ...state,
    [cityKey]: {
      ...(state[cityKey] || {}),
      [dateKey]: {
        ...(state[cityKey]?.[dateKey] || {}),
        isFetching: false,
        isInitialized: true,
      },
    },
  }),
});

export default currenciesAllTypesRates;
